import React from "react";

const InventoryOverviewCard = ({ label, data }) => {
  return (
    <div className="inventory-overview-card">
      <p className="inventory-overview-card-heading">{label}</p>
      <p className="inventory-overview-card-description">{data}</p>
    </div>
  );
};

export default InventoryOverviewCard;
